import React from "react";
import styles from "./timeline.module.css";
import InfoIcon from "../../../../../../../Icons/InfoIcon";
import { ClockIcon } from "../../../../../../../Icons/clockIcon";
import { TIMELINE_LINE_BACKGROUND } from "./timeline.constants";
import { SentIcon } from "../../../../../../../Icons/sentIcon";
import { MessageIcon } from "../../../../../../../Icons/messageIcon";
import { RefreshIcon } from "../../../../../../../Icons/refreshIcon";
import { CommentItemType } from "../../../../../../createEscalation.models";

type TimelineProps = {
    type: CommentItemType;
};

export const Timeline = ({ type }: TimelineProps) => {
    const { DRAFT_COMMENT, ESCALATION_RAISED, EMAIL_SENT, COMMENT_ADDED, STATUS_CHANGED } = CommentItemType;

    const renderIcon = () => {
        switch (type) {
            case DRAFT_COMMENT:
                return <InfoIcon />;
            case ESCALATION_RAISED:
                return <InfoIcon />;
            case EMAIL_SENT:
                return <SentIcon />;
            case COMMENT_ADDED:
                return <MessageIcon />;
            case STATUS_CHANGED:
                return <RefreshIcon />;
            default:
                return <ClockIcon />;
        }
    };

    return (
        <div className={styles.timelineNode}>
            <div className={styles.iconWrapper} style={{ background: TIMELINE_LINE_BACKGROUND[type] }}>{renderIcon()}</div>
        </div>
    );
};
